<!-- TITLE BAR -->

<kendo-dialog-titlebar (close)="cancel()">
  <div class="ss-dialog-title">
    {{ "module.catalog.add-to-cart-popup.title" | translate }}
  </div>
</kendo-dialog-titlebar>

<!-- CONTENT -->

<div class="ss-popup-container">
  <app-loader *ngIf="isLoading"></app-loader>
  <app-item-detail
    [quantity]="data.quantity"
    [popupMode]="data.popupMode"
    [product]="data.product"
    [customerProductComponentList]="data.customerProductComponentList"
    [canSeePrice]="data.canSeePrice"
    [caller]="data.caller"
    (addToCartClicked)="handleAddToCardClickedEvent($event)"
    (toggleIsLoading)="updateToggleIsLoading($event)"
    (closePopup)="this.cancel()"
  ></app-item-detail>
</div>
